import * as React from 'react';
import { InputField } from '../../components/fields/input.field';
import { Field } from '../../components/libs/form.lib';
import { Validators } from '../../components/libs/Validators';

// tslint:disable

export class InputPrompt extends React.Component<any, any> {

    public state: any = {
        isValid: false
    };

    private field: Field = new Field({
        title: this.props.CONFIG.title || 'Value'
    });

    componentDidMount() {
        this.field.onValueChanges$.subscribe((value: any) => {
            // console.log(value);
        });
    }

    onSubmit() {
        this.field.runValidators();

        if (this.field.isValid && this.field.value) {
            if (this.props.CONFIG.onSubmit) {
                this.props.CONFIG.onSubmit(this.field.value);

                if (this.props.IS_MODAL && this.props.PARENT_CONTEXT && this.props.PARENT_CONTEXT.props && this.props.PARENT_CONTEXT.props.parentContext && this.props.PARENT_CONTEXT.props.parentContext.onCloseModal) {
                    this.props.PARENT_CONTEXT.props.parentContext.onCloseModal();
                }
            }
        }
    }

    render() {
        return (
            <div className="col-xs-12">
                <InputField field={this.field} validators={[Validators.required('Required')]}/>

                <div className="form-group">
                    <button className="btn btn-primary" onClick={() => this.onSubmit()}>Submit</button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/libs/input-prompt.tsx